export const LogoMark = ({ size = 28, inverted = false, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill={inverted ? "#FFFFFF" : "#0A0A0A"} />
    <path d="M42 17H27a7.5 7.5 0 0 0 0 15h10a7.5 7.5 0 0 1 0 15H21" fill="none" stroke={inverted ? "#0A0A0A" : "#FFFFFF"} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="47" cy="47" r="3.6" fill="#C85A32" />
  </svg>
);

export const Logo = ({ size = 28, inverted = false, className = "", testId = "brand-logo" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid={testId}>
    <LogoMark size={size} inverted={inverted} />
    <span className={`font-display leading-none tracking-[0.14em] ${inverted ? "text-white" : "text-black"}`} style={{ fontSize: size * 0.62 }}>SALVILO</span>
  </div>
);
